import script from "./BulkSelectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkSelectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BulkSelectionHeader.vue?vue&type=style&index=0&id=04d5132e&scoped=true&lang=css"

import exportComponent from "C:\\source\\kp1\\PartnerMypage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d5132e"]])

export default __exports__